// @ts-check

/** @type {NodeListOf<HTMLButtonElement>} */
const resetButtons = document.querySelectorAll(".js-search-reset");

/**
 * @param {HTMLButtonElement} resetButton
 */
const setupClickListener = resetButton =>
	resetButton.addEventListener("click", event => {
		event.preventDefault();

		/** @type {HTMLInputElement|null} */
		const searchInput = resetButton.parentElement.querySelector(
			'input[type="search"]'
		);

		if (searchInput !== null) {
			searchInput.value = "";
			searchInput.focus();
		}
	});

resetButtons.forEach(setupClickListener);
